import React, { useState, useEffect } from 'react';
import { blockedIPsAPI } from '../utils/api';

const BlockedIPs = () => {
  const [blockedIPs, setBlockedIPs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);
  const [newIP, setNewIP] = useState({ ip_address: '', reason: '', blocked_by: 'admin' });

  useEffect(() => {
    loadBlockedIPs();
  }, []);

  const loadBlockedIPs = async () => {
    try {
      const data = await blockedIPsAPI.getAll();
      setBlockedIPs(data);
    } catch (error) {
      console.error('Failed to load blocked IPs:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleBlock = async (e) => {
    e.preventDefault();
    try {
      await blockedIPsAPI.create(newIP);
      setShowAddModal(false);
      setNewIP({ ip_address: '', reason: '', blocked_by: 'admin' });
      loadBlockedIPs();
    } catch (error) {
      console.error('Failed to block IP:', error);
      alert('Ошибка при блокировке IP');
    }
  };

  const handleUnblock = async (id) => {
    if (!window.confirm('Разблокировать этот IP адрес?')) return;
    
    try {
      await blockedIPsAPI.delete(id);
      loadBlockedIPs();
    } catch (error) {
      console.error('Failed to unblock IP:', error);
      alert('Ошибка при разблокировке IP');
    }
  };

  if (loading) {
    return <div className="text-center py-12">Загрузка...</div>;
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Блокировка IP адресов</h1>
          <p className="text-gray-600 mt-2">Управление заблокированными IP для предотвращения спама</p>
        </div>
        <button
          onClick={() => setShowAddModal(true)}
          className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition"
        >
          + Заблокировать IP
        </button>
      </div>

      <div className="bg-white rounded-lg shadow-sm overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                IP Адрес
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Причина
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Заблокирован
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Дата блокировки
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Действия
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {blockedIPs.map((ip) => (
              <tr key={ip.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  {ip.ip_address}
                </td>
                <td className="px-6 py-4 text-sm text-gray-500">
                  {ip.reason || 'Не указана'}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {ip.blocked_by}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {new Date(ip.blocked_at).toLocaleDateString('ru-RU')}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <button
                    onClick={() => handleUnblock(ip.id)}
                    className="text-red-600 hover:text-red-900"
                  >
                    Разблокировать
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {blockedIPs.length === 0 && (
          <div className="text-center py-12 text-gray-500">
            Заблокированные IP адреса отсутствуют
          </div>
        )}
      </div>

      {showAddModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-md w-full p-6">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Заблокировать IP адрес</h2>
            <form onSubmit={handleBlock} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  IP Адрес *
                </label>
                <input
                  type="text"
                  required
                  value={newIP.ip_address}
                  onChange={(e) => setNewIP({ ...newIP, ip_address: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  placeholder="192.168.1.1"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Причина
                </label>
                <textarea
                  value={newIP.reason}
                  onChange={(e) => setNewIP({ ...newIP, reason: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  rows="3"
                  placeholder="Спам, повторяющиеся заявки и т.д."
                />
              </div>
              <div className="flex space-x-3">
                <button
                  type="submit"
                  className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg font-medium transition"
                >
                  Заблокировать
                </button>
                <button
                  type="button"
                  onClick={() => setShowAddModal(false)}
                  className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 py-2 rounded-lg font-medium transition"
                >
                  Отмена
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default BlockedIPs;